import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const { Text } = Typography;

export const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);

    try {
      const result = await login(values.username, values.password);

      if (result.success) {
        message.success('Login successful!');
        navigate('/');
      } else {
        // Handle unconfirmed user - redirect to verification
        if (result.errorCode === 'UserNotConfirmedException') {
          message.warning('Please verify your account first');
          navigate('/verify', { state: { phone: values.username } });
        } else {
          message.error(result.error || 'Invalid credentials');
        }
      }
    } catch (error: any) {
      console.error('Login error:', error);
      message.error(error.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #003874 0%, #94AFCC 100%)'
    }}>
      <Card
        style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img src="/logo.png" alt="ShadesParking" style={{ height: 96 }} />
        </div>
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="Email or Phone"
            name="username"
            rules={[{ required: true, message: 'Please input your email or phone!' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="email@example.com or +971501234567" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Log in
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center' }}>
            <Text>Don't have an account? </Text>
            <Link to="/register">Register</Link>
          </div>
        </Form>
      </Card>
    </div>
  );
};
